import { ToLocaleDateTimeBaseValueConverter } from 'General/Resources/ValueConverters/ToLocaleDateTimeBase';
export class ToLocaleDateTimeValueConverter extends ToLocaleDateTimeBaseValueConverter {

}